var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "_indexPage"
  }, [_vm.theme == 'tapcoin' ? _c('tapcoin-index') : _vm.theme == 'rocket' ? _c('rocket-index') : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };